import React from "react";
import RouteContainer from "./Router.js";

const MainApp = () => {
  return <RouteContainer />;
};

export default MainApp;
